import Services from "../../../services"

class RealisasiPPAApi {
  getPage(params) {
    return Services.get("/ang/ppa_realisasi/page", {params})
  }

  getKode(date) {
    return Services.get("/ang/ppa_realisasi/no_baru", {
      params: {
        tanggal: date
      }
    })
  }

  uploadBukti(value) {
    return Services.post("/ang/upload/bukti", value)
  }

  createOrUpdate(values) {
    return Services.post("/ang/ppa_realisasi", values)
  }

  delete(data) {
    return Services.post("/ang/ppa/delete", data)
  }
}

export default new RealisasiPPAApi()
